import { render } from "./singleHouseHold.vue?vue&type=template&id=3ebde4e4&scoped=true&ts=true"
import script from "./singleHouseHold.vue?vue&type=script&lang=ts"
export * from "./singleHouseHold.vue?vue&type=script&lang=ts"

import "./singleHouseHold.vue?vue&type=style&index=0&id=3ebde4e4&lang=scss&scoped=true"
import "./singleHouseHold.vue?vue&type=style&index=1&id=3ebde4e4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebde4e4"]])

export default __exports__